import React from "react";
import { Button } from "reactstrap";

import env from "../../environment";
import { AUTOPILOT_COLORS } from "../autopilot/styles";

// Link para o manual do MeuFrete (PO1-3188). O PDF é servido pelo backend, em
// /public/manual-transportadora.pdf, e não pela pasta public/ do front: a regra de SPA
// do Amplify captura extensões fora da lista padrão e devolveria o index.html no lugar
// do arquivo (medido em 23/09/2026 — ".pdf" inexistente responde 200 com HTML).
//
// Rota pública de propósito: o mesmo link vai no e-mail de boas-vindas, que a
// transportadora abre antes de estar logada.

export const MANUAL_TRANSPORTADORA_URL = `${env.API_URL}/public/manual-transportadora.pdf`;

export default function ManualDoPortalButton({ size = "sm", children }) {
  return (
    <Button
      size={size}
      color="info"
      outline
      href={MANUAL_TRANSPORTADORA_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Abre o manual do portal em PDF, numa nova aba"
      style={{ color: AUTOPILOT_COLORS.accent }}
    >
      <i className="tim-icons icon-single-copy-04" style={{ marginRight: "0.35rem" }} />
      {children || "Manual do portal"}
    </Button>
  );
}
